import { render, staticRenderFns } from "./customEvent.vue?vue&type=template&id=1c6d7eb8&"
import script from "./customEvent.js?vue&type=script&lang=js&"
export * from "./customEvent.js?vue&type=script&lang=js&"
import style0 from "./customEvent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports